<div class="list-wrapper" [ngClass]="{'block': blockStyle}" [ngStyle]="{'backgroundColor': blockStyle ? bgColor : ''}">
  <div class="flex-row space-between">
    <div *ngIf="hasAvatar" class="mr-sm">
      <bw-avatar [iconName]="avatarIconName" [iconColor]="avatarIconColor" avatarSize="medium"></bw-avatar>
    </div>
    <div *ngIf="hasLeftIcon" class="align-left mr-sm">
      <bw-icon-legacy [iconName]="leftIconName" size="24" [color]="leftIconColor"></bw-icon-legacy>
    </div>
    <div class="flex-column flex-item-flexible">
      <typography-legacy *ngIf="hasTitle" class="type-sm-bold primary-text">{{listTitle}}</typography-legacy>
      <typography-legacy *ngIf="hasDetail" class="type-sm primary-text">{{listDetail}}</typography-legacy>
    </div>
    <div *ngIf="hasRightIcon" class="align-right ml-sm">
      <bw-icon-legacy [iconName]="rightIconName" size="24" [color]="rightIconColor"></bw-icon-legacy>
    </div>
  </div>
</div>
<div class="mb-sm"></div>
